export enum EditableFieldTypes {
  Text,
  TextArea,
  RichText,
  Header,
  Card,
}
